import { Injectable } from '@angular/core';
import { WorkflowApiService, WorkflowApiUpdateInfo } from '@selfai-platform/pipeline-api';
import { map, Observable, of } from 'rxjs';

@Injectable()
export class WorkflowSettingsDomainService {
  constructor(private readonly workflowApiService: WorkflowApiService) {}

  update(workflowId: string, updateInfo: WorkflowApiUpdateInfo): Observable<void> {
    return this.workflowApiService.updateWorkflowInfo(workflowId, updateInfo).pipe(map((): void => void 0));
  }
}
